var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.52 19.48l-5.66 5.66M21.54 19.46a3 3 0 01.88-2.12l2.83-2.83a3 3 0 014.24 0h0a3 3 0 010 4.24l-2.83 2.83a3 3 0 01-2.29.87M22.46 24.54a3 3 0 01-.88 2.12l-2.83 2.83a3 3 0 01-4.24 0h0a3 3 0 010-4.24l2.83-2.83a3 3 0 012.29-.87"
  })));
}

export default SvgBind;